import { jsx as o, Fragment as j, jsxs as D } from "react/jsx-runtime";
import * as r from "react";
import { m as I } from "../node_modules/streamdown/dist/chunk-RLXIAIE6.js";
import { useCopilotInstruction as M } from "./global-state.js";
import { undent as N } from "../session.js";
const h = r.createContext(null), C = r.createContext(null);
function E({
  children: t,
  markdown: s,
  approval: a
}) {
  const { markdownComponents: i, extraComponentDescription: p } = r.useMemo(() => {
    const c = {}, m = {}, u = [], { code: g = R, pre: v = F, ...x } = s;
    for (const [n, e] of Object.entries(x))
      typeof e == "function" ? c[n] = e : e && typeof e.component == "function" && (m[n] = e.component, typeof e.description == "string" && e.description.trim().length > 0 && u.push(`### ${n}
${N(e.description).trim()}`));
    const y = v, k = g;
    return c.pre = function({ children: n, ...e }) {
      return (n?.props?.className ?? "") === "language-render-component" ? /* @__PURE__ */ o(j, { children: n }) : /* @__PURE__ */ o(y, { ...e, children: n });
    }, c.code = ({ className: n, children: e, ...d }) => {
      if (n === "language-render-component")
        try {
          const P = JSON.parse(e.trim()), { componentName: l, props: b } = P, f = m[l];
          return f == null ? /* @__PURE__ */ D("div", { children: [
            "Failed to render ",
            l
          ] }) : /* @__PURE__ */ o(f, { ...b });
        } catch {
          return /* @__PURE__ */ o("div", { children: "Failed to render custom component" });
        }
      return /* @__PURE__ */ o(k, { ...d, className: n, children: e });
    }, { markdownComponents: c, extraComponentDescription: u.join(`

`) };
  }, [s]);
  M({
    instruction: `## Content Guidelines

1. You have access to github flavored markdown. Lean on it to make your responses more readable and engaging.
${p.length > 0 ? `2. In addition. You are rendering this chat with a few special components.

  To securely render these components you must:

  1. Emit a code fence with the language \`render-component\`
  2. Insert JSON with a key of \`componentName\` and \`props\`. We will feed the props directly into the referenced react component.

  For example, if you have a component called \`ProfileCard\`, you use it like this:

  \`\`\`render-component
  { "componentName": "ProfileCard", "props": {"userId": "12345" } }
  \`\`\`

  When you emit this, this component will render as a React component in the chat.
  This syntax the equivalent of writing <ProfileCard userId="12345" /> in react.

List of available components:

${p}` : ""}`
  });
  const w = r.useMemo(() => ({ components: i }), [i]);
  return /* @__PURE__ */ o(h.Provider, { value: w, children: /* @__PURE__ */ o(C.Provider, { value: a ?? null, children: t }) });
}
function J() {
  return r.useContext(C);
}
function L({
  children: t,
  isAnimating: s = !1,
  animated: a
}) {
  const i = r.useContext(h);
  if (i == null)
    throw new Error("Markdown must be used within CopilotProvider");
  return /* @__PURE__ */ o(I, { components: i.components, animated: a, isAnimating: s, children: t });
}
function F(t) {
  return /* @__PURE__ */ o("pre", { ...t });
}
function R(t) {
  return /* @__PURE__ */ o("code", { ...t });
}
export {
  E as CopilotProvider,
  L as Markdown,
  J as useCopilotApproval
};
